import GatedFeature from './GatedFeature'

export default GatedFeature
